import { render, staticRenderFns } from "./noticeAddPage.vue?vue&type=template&id=2149f396&scoped=true&"
import script from "./noticeAddPage.vue?vue&type=script&lang=js&"
export * from "./noticeAddPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2149f396",
  null
  
)

export default component.exports